// Dados curados de emojis (sem dependências) + inserção pura na posição do
// cursor. Cada categoria tem um `icone` (emoji representativo, sem texto → sem
// i18n) e a lista de emojis.

export interface EmojiCategoria {
  icone: string;
  emojis: string[];
}

export const EMOJI_CATEGORIAS: EmojiCategoria[] = [
  {
    icone: '😀',
    emojis: ['😀','😃','😄','😁','😅','😂','🤣','🙂','😊','😉','😍','😘','😎','🤩','🥳','😜','🤔','😐','😴','😢','😭','😤','😡','🥺','😱','🤗','🙄','😬'],
  },
  {
    icone: '👍',
    emojis: ['👍','👎','👏','🙌','🙏','👌','✌️','🤝','💪','👋','🤙','🫶','🤞','👇','👆','🫡'],
  },
  {
    icone: '❤️',
    emojis: ['❤️','🧡','💛','💚','💙','💜','🖤','🤍','💔','❣️','💕','💞','💗','💖','💟'],
  },
  {
    icone: '🐶',
    emojis: ['🐶','🐱','🦁','🐼','🐵','🐸','🐧','🦄','🌸','🌺','🌻','🌳','🌵','🔥','⭐','🌈','☀️','🌙','⚡','💧'],
  },
  {
    icone: '🍕',
    emojis: ['🍕','🍔','🍟','🌮','🍣','🍜','🍎','🍌','🍓','🍇','🥑','☕','🍺','🍷','🥂','🎂','🍫','🍪'],
  },
  {
    icone: '🎉',
    emojis: ['🎉','🎊','🎁','✅','❌','⚠️','📌','💡','📞','✉️','🚀','💯','🔔','💰','📅','⏰','🕐','🙏'],
  },
];

export function insertEmoji(
  text: string,
  emoji: string,
  caret: number,
): { text: string; caret: number } {
  const pos = Math.max(0, Math.min(caret, text.length));
  return {
    text: text.slice(0, pos) + emoji + text.slice(pos),
    caret: pos + emoji.length,
  };
}
